import { render, staticRenderFns } from "./DataAccessSubscriptionPacks.vue?vue&type=template&id=11ffac22&scoped=true&"
import script from "./DataAccessSubscriptionPacks.vue?vue&type=script&lang=js&"
export * from "./DataAccessSubscriptionPacks.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessSubscriptionPacks.vue?vue&type=style&index=0&id=11ffac22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffac22",
  null
  
)

export default component.exports